<div class="invoice-review-wrapper">
  <button (click)="cancel()" mat-button color="primary">Cancel</button>
  <button (click)="verify()" mat-flat-button color="primary">
    <fa-duotone-icon class="verify-check-icon" [icon]="['fad', 'badge-check']">
    </fa-duotone-icon>
    Verify Expense
  </button>
</div>
